import { render, staticRenderFns } from "./SizeAutocomplete.vue?vue&type=template&id=31f98a3a"
import script from "./SizeAutocomplete.ts?vue&type=script&lang=ts&external"
export * from "./SizeAutocomplete.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports